import { useDataValue } from 'Simple/Data.js'

export default function useGetDefaultTab(props, data) {
  let is_new_statements_default_enabled = useDataValue({
    context: 'global',
    path: 'feature_flags.is_new_statements_default_enabled',
    viewPath: props.viewPath,
  })

  return function ensureDefaultTab(maybeTab, id) {
    if (maybeTab?.selected) return maybeTab

    return {
      ...data,
      viewPath: props.viewPath,
      selected: {
        ...data.selected,
        statements: {
          ...data.selected.statements,
          new: is_new_statements_default_enabled,
        },
      },
    }
  }
}
